import AddToModuleSuccess from "./AddToModuleSuccess";

export default AddToModuleSuccess;
